module.exports = __webpack_public_path__ + "img/card_img_eight.38240972.png";